import React, { useContext, useMemo } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.less";
import Layout from "./Layout";
import { AuthContext } from "context/AuthContext";
import { RoleLevelEnum } from "constraints/RoleLevelEnum";

const PrivateRoute = ({ children, redirectTo, isAuth, requiredRoleLevel }) => {
  const { user } = useContext(AuthContext);

  if (!isAuth) {
    return <Navigate to={redirectTo} />;
  }

  if (
    typeof requiredRoleLevel === "number" &&
    user?.roleLevel < requiredRoleLevel
  ) {
    return <Navigate to={redirectTo} />;
  }

  return children;
};

export const App = () => {
  const { user } = useContext(AuthContext);
  const { isAuth } = useMemo(() => {
    return { isAuth: Boolean(user?.userName), roleLevel: user?.roleLevel };
  }, [user]);

  return (
    <Routes>
      <Route index path="/" element={<Layout.HomePage />} />
      <Route path="/login" element={<Layout.Login />} />
      <Route path="/lucky-draw" element={<Layout.LuckyRaw />} />
      <Route path="/cart-public" element={<Layout.CartPublic />} />
      <Route path="/winners" element={<Layout.LuckyRawWinners />} />

      {/* Cần đăng nhập, không yêu cầu role */}
      <Route
        path="/qr-scan"
        element={
          <PrivateRoute isAuth={isAuth} redirectTo="/login">
            <Layout.QRScan />
          </PrivateRoute>
        }
      />
      <Route
        path="/cart"
        element={
          <PrivateRoute isAuth={isAuth} redirectTo="/login">
            <Layout.Cart />
          </PrivateRoute>
        }
      />
      <Route
        path="/cart-private"
        element={
          <PrivateRoute isAuth={isAuth} redirectTo="/login">
            <Layout.CartPrivate />
          </PrivateRoute>
        }
      />
      <Route
        path="/view-360"
        element={
          <PrivateRoute isAuth={isAuth} redirectTo="/login">
            <Layout.View360 />
          </PrivateRoute>
        }
      />
      <Route
        path="/live-stream"
        element={
          <PrivateRoute isAuth={isAuth} redirectTo="/login">
            <Layout.LiveStream />
          </PrivateRoute>
        }
      />

      {/* Cần đăng nhập + roleLevel >= MANAGERAGENT */}
      <Route
        path="/lucky-draw-customers"
        element={
          <PrivateRoute
            isAuth={isAuth}
            redirectTo="/login"
            requiredRoleLevel={RoleLevelEnum.MANAGERAGENT}
          >
            <Layout.LuckyRawCustomers />
          </PrivateRoute>
        }
      />

      <Route path="*" element={<Layout.HomePage />} />
    </Routes>
  );
};

export default App;
